import { useQuery } from '@tanstack/react-query';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';

import { getIsPlanningComplete } from './useIsPlanningComplete';

interface IUsePlanningStatusParams {
	planningType: PlanningTypes;
	cycleId: number;
	companyAreaId?: number;
}

export const usePlanningStatus = ({
	planningType,
	cycleId,
	companyAreaId,
}: IUsePlanningStatusParams) => {
	const isCollaboration = planningType
		?.toLowerCase()
		.includes('collaboration');

	const queryKey = [
		'is-complete',
		planningType,
		cycleId,
		companyAreaId || '',
	];

	const isEnabled =
		!!planningType &&
		!!cycleId &&
		cycleId > 0 &&
		(!isCollaboration || (!!companyAreaId && companyAreaId > 0));

	const {
		data: statusData,
		isLoading,
		isError,
	} = useQuery({
		queryKey,
		queryFn: async () => {
			return await getIsPlanningComplete({
				planningType,
				cycleId,
				companyAreaId,
			});
		},
		enabled: isEnabled,
		staleTime: Infinity,
		retry: false,
	});
	return {
		statusData,
		isLoading,
		isError,
		isCollaboration,
		canFinalize: !isLoading && !isError && !statusData,
	};
};
